export function fixHtmlForProseMirror(content) {
    if (typeof content === 'string' && !/<p>.*<p>/i.test(content)) {
        content = content.replace(/<\/(a|span|em|strong|strike)><\/p>\s*$/i, '</$1> </p>');
    }

    return content;
}
